/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Czech
export default {
  'ai-mate.agent-header-banner-label': 'Banner agenta',
  'ai-mate.agent-list.all-agents-section-title': 'Všichni agenti',
  'ai-mate.agent-list.beta-lozenge-title': 'Beta',
  'ai-mate.agent-list.change-owner-success-flag-description':
    'Změnili jste vlastníka agenta {agentName} na uživatele {newOwnerName}.',
  'ai-mate.agent-list.change-owner-success-flag-title': 'Vlastník byl úspěšně změněn',
  'ai-mate.agent-list.delete-agent-confirm-body': 'Opravdu chcete odstranit tohoto agenta? Akci nejde vrátit zpět.',
  'ai-mate.agent-list.delete-agent-confirm-title': 'Odstranit agenta „{agentName}“?',
  'ai-mate.agent-list.delete-agent-error': 'Odstranění agenta se nezdařilo.',
  'ai-mate.agent-list.delete-agent-error-flag-description':
    'Při odstraňování agenta došlo k chybě. Zkuste to za chvíli znovu.',
  'ai-mate.agent-list.delete-agent-error-flag-title': 'Odstranění agenta se nezdařilo',
  'ai-mate.agent-list.delete-agent-error.agent-in-use': 'Agent se aktuálně používá. Zkuste to znovu později.',
  'ai-mate.agent-list.delete-agent-error.agent-not-found': 'Daného agenta se nepodařilo najít.',
  'ai-mate.agent-list.delete-agent-error.incorrect-owner':
    'Agenty, které jste sami nevytvořili, nemůžete odstranit. Obraťte se na vlastníka agenta.',
  'ai-mate.agent-list.delete-agent-success-flag-description': 'Odstranili jste agenta {agentName}.',
  'ai-mate.agent-list.delete-agent-success-flag-title': 'Agent byl odstraněn',
  'ai-mate.agent-list.development-section-title': 'Vývojoví agenti',
  'ai-mate.agent-list.load-more-button-loading': 'Načítání dalších agentů…',
  'ai-mate.agent-list.load-more-button-ready': 'Načíst další',
  'ai-mate.agent-list.loading-agents': 'Načítání agentů…',
  'ai-mate.agent-list.no-results': 'Pro termín „{searchValue}“ nebyly nalezeny žádné výsledky',
  'ai-mate.agent-list.recommended-agents-section-title': 'Doporučené',
  'ai-mate.agent-list.searching-agents': 'Vyhledávání agentů…',
  'ai-mate.agent-list.templates-description':
    'Tyto šablony použijte k vytvoření vlastního vývojářského agenta. Vyberte správnou šablonu agenta pro svou práci, vyberte možnost Použít šablonu a poté vyplňte výzvu šablony konkrétními podrobnostmi, jako je repozitář, složka, jazyk a knihovna. Vytvářejte vývojářské agenty na míru pro kódování různých úkolů, projektů nebo repozitářů.',
  'ai-mate.agent-list.templates-lozenge-title': 'Šablona',
  'ai-mate.agent-list.templates-title': 'Šablony kódování',
  'ai-mate.agent-message.agent-not-found': 'Agent nebyl nalezen',
  'ai-mate.agent-message.convo-title': 'Chat s agentem {agentName} spuštěný z vloženého chytrého odkazu',
  'ai-mate.agent-message.copy-link': 'Kopírovat odkaz na agenta',
  'ai-mate.agent-message.prompt': 'Výzva',
  'ai-mate.agent-message.prompt-placeholder': 'Zadejte zprávu pro agenta {agentName}.',
  'ai-mate.agent-message.prompt-submit': 'Odeslat',
  'ai-mate.agent-message.view-profile': 'Zobrazit profil',
  'ai-mate.agent-modal.agent-delete-confirm.cancel-text': 'Zrušit',
  'ai-mate.agent-modal.agent-delete-confirm.confirm-text': 'Odstranit',
  'ai-mate.agent-picker.dropdown-item.non-default-agent-prefix': 'Agent · {description}',
  'ai-mate.agent-profile-info.chat-with-agent': 'Chatovat s agentem {agentName}',
  'ai-mate.agent-profile-info.copy-agent-link-clicked-tooltip': 'Zkopírovaná adresa URL',
  'ai-mate.agent-profile-info.copy-agent-link-tooltip': 'Kopírovat odkaz',
  'ai-mate.agent-profile-info.hidden-icon': 'Skryté',
  'ai-mate.agent-profile-info.hidden-tooltip': 'Agent se nezobrazí ve výsledcích vyhledávání.',
  'ai-mate.agent-profile-info.star-agent-tooltip': 'Přidat agenta do oblíbených',
  'ai-mate.agent-selector.agent-not-found': 'Agent nebyl nalezen',
  'ai-mate.agent-selector.default-agent-description':
    'Získejte odpovědi, generujte nové nápady a zrychlete každodenní práci.',
  'ai-mate.agent-selector.default-agent-name': 'Chat',
  'ai-mate.browse-agents-view.close-button': 'Zavřít zobrazení agentů',
  'ai-mate.browse-agents.scenario-pill.default-scenario-tag': 'Výchozí',
  'ai-mate.browse-agents.scenario-pill.inactive-scenario-tooltip': 'Neaktivní',
  'ai-mate.profile-card-preview.actions-title': 'Akce',
  'ai-mate.profile-card-preview.agent-default-title': 'Agent',
  'ai-mate.profile-card-preview.agent-description-label': 'Popis',
  'ai-mate.profile-card-preview.agent-title-label': 'Název',
  'ai-mate.profile-card-preview.conversation-starters-heading': 'Spouštěče konverzace',
  'ai-mate.profile-card-preview.empty-actions': '–',
  'ai-mate.profile-card-preview.empty-conversation-starters': '–',
  'ai-mate.profile-card-preview.empty-instructions': '–',
  'ai-mate.profile-card-preview.empty-knowledge-scope': 'Nic nevybráno',
  'ai-mate.profile-card-preview.instructions-title': 'Pokyny',
  'ai-mate.profile-card-preview.knowledge-title': 'Znalosti',
  'ai-mate.profile-card-preview.regenerate-label': 'Znovu vygenerovat položku {fieldName}',
  'conversation-assistant-agent.create-agent.agent-name-copy': '{agentName} – kopie',
  'conversation-assistant-agent.create-agent.conversation-starters.drag-handle-label': 'Přetažením změníte pořadí.',
  'conversation-assistant-agent.create-agent.conversation-starters.form-error': 'Změny se nepodařilo uložit.',
  'conversation-assistant-agent.create-agent.conversation-starters.form-generic-error':
    'Došlo k neznámé chybě. Zkuste to znovu.',
  'conversation-assistant-agent.create-agent.conversation-starters.form-name-exists-error':
    'Agent s tímto názvem už existuje.',
  'conversation-assistant-agent.create-agent.conversation-starters.remove-label': 'Odebrat',
  'conversation-assistant-agent.create-agent.generate-conversation-starters-button-text':
    'Vygenerovat spouštěče konverzací',
  'conversation-assistant-agent.create-agent.input-max-length-error-message':
    '{maxLength, plural, one {Pole {fieldName} nesmí mít více než {maxLength,number} znak.} few {Pole {fieldName} nesmí mít více než {maxLength,number} znaky.} many {Pole {fieldName} nesmí mít více než {maxLength,number} znaku.} other {Pole {fieldName} nesmí mít více než {maxLength,number} znaků.}}',
  'conversation-assistant-agent.create-agent.next-step-button-label': 'Další',
  'conversation-assistant-agent.create-agent.restart-creation-button-label': 'Restartovat',
  'conversation-assistant-agent.create-agent.skip-to-manual-setup-button-label': 'Přeskočit na ruční nastavení',
  'create-agent.owner-field.confirm-modal-cancel': 'Zrušit',
  'create-agent.owner-field.confirm-modal-confirm': 'Ano, pokračovat',
  'create-agent.owner-field.confirm-modal-content':
    'Chystáte se změnit vlastníka tohoto agenta na uživatele {name}. Když to uděláte, nebudete už moci tohoto agenta upravovat ani spravovat.',
  'create-agent.owner-field.confirm-modal-title': 'Ztratíte přístup k úpravám',
  'create-agent.owner-field.owner-description': 'Toto je osoba, která může agenta upravovat nebo spravovat.',
  'create-agent.owner-field.owner-label': 'Vlastník',
  'rovo-chat.agent-card.deactivated-name': '{name} (deaktivovaný uživatel)',
  'rovo-chat.browse-agents.agents-error-rate-limited-message': 'Žádostí je příliš mnoho. Chvíli počkejte.',
  'rovo-chat.browse-agents.agents-error-try-again-button': 'Zkusit znovu',
  'rovo-chat.browse-agents.all-agents-button': 'Vše',
  'rovo-chat.browse-agents.close-button': 'Zavřít',
  'rovo-chat.browse-agents.create-agent-button': 'Vytvořit',
  'rovo-chat.browse-agents.create-an-agent-button': 'Vytvořit agenta',
  'rovo-chat.browse-agents.create-button-disabled-tooltip': 'Nemáte oprávnění k vytváření agentů na tomto webu.',
  'rovo-chat.browse-agents.created-by-label': '<text>od</text> {creatorName}',
  'rovo-chat.browse-agents.development-button': 'Agenti kódování',
  'rovo-chat.browse-agents.favorite-agents-button': 'Oblíbené',
  'rovo-chat.browse-agents.favourited-agent-label': 'Agent v oblíbených',
  'rovo-chat.browse-agents.modal-title': 'Procházet agenty',
  'rovo-chat.browse-agents.my-agents-button': 'Moji agenti',
  'rovo-chat.browse-agents.no-created-agents':
    'Zdá se, že jste ještě nevytvořili žádné agenty. Začněte duplikováním jiných existujících agentů, nebo vytvořte nového od nuly.',
  'rovo-chat.browse-agents.no-created-agents-header': 'Zatím nebyli vytvořeni žádní agenti',
  'rovo-chat.browse-agents.no-created-agents-header-no-permission': 'Nevytvořili jste žádné agenty',
  'rovo-chat.browse-agents.no-created-agents-no-permission':
    'K vytváření agentů Rovo na tomto webu potřebujete oprávnění od správce.',
  'rovo-chat.browse-agents.no-starred-agents':
    'Pokud máte oblíbeného agenta nebo agenta, kterého často používáte, označte jej hvězdičkou, abyste k němu měli snadný přístup.',
  'rovo-chat.browse-agents.no-starred-agents-header': 'Zatím jste žádného agenta nepřidali do oblíbených',
  'rovo-chat.browse-agents.search-input.placeholder': 'Vyhledat agenty',
  'rovo-chat.browse-agents.search-templates-input.placeholder': 'Vyhledat šablony',
  'rovo-chat.browse-agents.see-all-agents-button': 'Zobrazit všechny agenty',
  'rovo-chat.browse-agents.templates-button': 'Šablony',
  'rovo-chat.create-agent.actions-section-description':
    'Přidejte pro svého agenta akce k provádění úkolů v Jira, Confluence a Jira Service Management. <link>Co jsou akce agentů?</link>',
  'rovo-chat.create-agent.add-actions-button-label': 'Přidat akce',
  'rovo-chat.create-agent.all-content-label': 'Veškerý obsah',
  'rovo-chat.create-agent.back-button': 'Zpět',
  'rovo-chat.create-agent.beta-lozenge': 'Beta',
  'rovo-chat.create-agent.confirm-leave-modal.body': 'Ještě jste svého agenta nevytvořili, chcete ho zrušit?',
  'rovo-chat.create-agent.confirm-leave-modal.cancel-button': 'Zrušit',
  'rovo-chat.create-agent.confirm-leave-modal.confirm-button': 'Ano, zrušit agenta',
  'rovo-chat.create-agent.confirm-leave-modal.title': 'Nedokončený agent',
  'rovo-chat.create-agent.confirm-restart-modal.body':
    'Opravdu chcete zahodit změny, které jste provedli u tohoto agenta?',
  'rovo-chat.create-agent.confirm-restart-modal.confirm-button': 'Potvrdit',
  'rovo-chat.create-agent.confirm-restart-modal.title': 'Restartovat vytváření',
  'rovo-chat.create-agent.confluence-checkbox-label': 'Confluence',
  'rovo-chat.create-agent.conversation-starters-field-description':
    'Lidé je mohou využít k zahájení chatu s agentem. Pokud žádné nedokážete vymyslet, můžeme je vygenerovat za vás.',
  'rovo-chat.create-agent.conversation-starters-field-label': 'Spouštěče konverzace',
  'rovo-chat.create-agent.create-agent-button': 'Vytvořit',
  'rovo-chat.create-agent.ctions-section-title': 'Akce',
  'rovo-chat.create-agent.description-field-description':
    'Lidé se o agentovi mohou dozvědět více díky popisu v jeho profilu.',
  'rovo-chat.create-agent.description-field-label': 'Popis',
  'rovo-chat.create-agent.description-field-placeholder':
    'Napište krátký popis svého agenta (například kreativní autor pro marketingové blogy).',
  'rovo-chat.create-agent.instructions-field-description':
    'Jak se má tento agent chovat? Co může dělat? <link>Další informace o psaní pokynů pro agenta</link>',
  'rovo-chat.create-agent.instructions-field-label': 'Pokyny',
  'rovo-chat.create-agent.instructions-field-placeholder': 'Přizpůsobte pokyny pro tohoto agenta.',
  'rovo-chat.create-agent.intro-description-part-1':
    'Vytvořte agenta se specializovanými znalostmi, který bude odpovídat na otázky, psát a kontrolovat obsah a provádět úkoly, abyste posunuli svou práci vpřed.',
  'rovo-chat.create-agent.intro-description-part-2':
    'Pokud nepotřebujete pomoc, můžete <bold>přeskočit na ruční nastavení</bold>.',
  'rovo-chat.create-agent.intro-description-part-3': 'Jinak zůstaňte tady a můžeme agenta navrhnout společně.',
  'rovo-chat.create-agent.intro-step-1-content':
    'Na základě toho, co napíšete, vytvořím pokyny pro agenta. Stačí mi říct, k čemu plánujete agenta používat.',
  'rovo-chat.create-agent.intro-step-1-title': 'Popište, co chcete, aby váš agent dělal',
  'rovo-chat.create-agent.intro-step-2-content':
    'Pojďme společně rozhodnout o jménu a osobnosti vašeho agenta. Řekněte mi, jestli je váš agent empatický, přímý nebo vtipný.',
  'rovo-chat.create-agent.intro-step-2-title': 'Okořeňte to trochou osobnosti',
  'rovo-chat.create-agent.intro-step-3-content':
    'Vyberte možnost <bold>Další</bold>, abyste mohli svého nového agenta zkontrolovat a přidat akce, znalosti a profilový obrázek. Až budete hotovi, vyberte možnost <bold>Vytvořit</bold>.',
  'rovo-chat.create-agent.intro-step-3-content-skills':
    'Použijte tlačítko <bold>Další</bold>, abyste mohli svého nového agenta zkontrolovat a přidat dovednosti, znalosti a profilový obrázek. Až budete hotovi, vyberte možnost <bold>Vytvořit</bold>.',
  'rovo-chat.create-agent.intro-step-3-title': 'Zkontrolujte a vytvořte svého agenta',
  'rovo-chat.create-agent.intro-title': '👋 Pojďme vytvořit vašeho agenta',
  'rovo-chat.create-agent.jira-checkbox-label': 'Jira',
  'rovo-chat.create-agent.jira-filter-placeholder': 'Všechny projekty',
  'rovo-chat.create-agent.jira-filter-placeholder-galaxia': 'Všechny prostory',
  'rovo-chat.create-agent.jsm-checkbox-label': 'Jira Service Management',
  'rovo-chat.create-agent.jsm-filter-knowledge-base-placeholder': 'Prohledat znalostní bázi',
  'rovo-chat.create-agent.knowledge-field-description':
    'Specifikujte znalosti agenta tak, že mu umožníte odkazovat pouze na zdroje, které poskytnete.',
  'rovo-chat.create-agent.knowledge-field-label': 'Znalosti',
  'rovo-chat.create-agent.knowledge-scope-checkbox-label': 'Odkazovat pouze na tyto zdroje',
  'rovo-chat.create-agent.knowledge-select.object-resolver-label': 'Odkazy',
  'rovo-chat.create-agent.knowledge-select.suggestion-label': 'Navrhované',
  'rovo-chat.create-agent.manage-actions-button-label': 'Spravovat akce',
  'rovo-chat.create-agent.name-field-description': 'Lidé mohou tuto funkci použít k vyhledání agenta.',
  'rovo-chat.create-agent.name-field-label': 'Název',
  'rovo-chat.create-agent.name-field-placeholder': 'Pojmenujte svého agenta.',
  'rovo-chat.create-agent.natural-language-form-creator.generic-error': 'Došlo k neočekávané chybě. Zkuste to znovu.',
  'rovo-chat.create-agent.natural-language-form-creator.static-first-message':
    'Zdravím! Pomůžu vám sestavit vlastního agenta. Povězte mi, co chcete, aby váš agent dělal?',
  'rovo-chat.create-agent.nl-input-field.input-label': 'Vytvořit agenta',
  'rovo-chat.create-agent.nl-input-field.placeholder': 'Zadejte svou zprávu.',
  'rovo-chat.create-agent.nl-input-field.send-button-label': 'Odeslat',
  'rovo-chat.create-agent.page-title': 'Vytvořit agenta',
  'rovo-chat.create-agent.page-title-edit': 'Upravit agenta',
  'rovo-chat.create-agent.search-for-pages-placeholder': 'Vyhledat stránky',
  'rovo-chat.create-agent.search-for-spaces-placeholder': 'Vyhledat prostory',
  'rovo-chat.create-agent.select-action-modal-all-tab-title': 'Vše',
  'rovo-chat.create-agent.select-action-modal-beta-tag': 'Beta',
  'rovo-chat.create-agent.select-action-modal-cancel-button': 'Zrušit',
  'rovo-chat.create-agent.select-action-modal-close-icon-tooltip': 'Zavřít',
  'rovo-chat.create-agent.select-action-modal-confluence-tab-title': 'Confluence',
  'rovo-chat.create-agent.select-action-modal-jira-tab-title': 'Jira',
  'rovo-chat.create-agent.select-action-modal-many-actions-added-warning':
    '{count, plural, one {Optimální výkon zajistíte výběrem méně než {count,number} akce.} few {Optimální výkon zajistíte výběrem méně než {count,number} akcí.} many {Optimální výkon zajistíte výběrem méně než {count,number} akce.} other {Optimální výkon zajistíte výběrem méně než {count,number} akcí.}}',
  'rovo-chat.create-agent.select-action-modal-save-button': 'Uložit',
  'rovo-chat.create-agent.select-action-modal-search-input-placeholder': 'Vyhledat akce',
  'rovo-chat.create-agent.select-action-modal-title': 'Přidat akce',
  'rovo-chat.create-agent.select-content-under-label': 'Vybrat obsah pod',
  'rovo-chat.create-agent.select-spaces-label': 'Vybrat prostory',
  'rovo-chat.create-agent.selected-actions-label': 'Vybrané akce:',
  'rovo-chat.create-agent.unknown-owner': 'Neznámý',
  'rovo-chat.create-agent.update-agent-button': 'Aktualizovat',
  'rovo-chat.edit-agent.confirm-discard-modal.body':
    'Když budete pokračovat, ztratíte neuložené změny. Chcete-li pokračovat v úpravách tohoto agenta, vyberte možnost Zrušit.',
  'rovo-chat.edit-agent.confirm-discard-modal.confirm-button': 'Pokračovat, zahodit změny',
  'rovo-chat.edit-agent.confirm-discard-modal.title': 'Zahodit změny',
  'rovo-chat.view-agent.about-label': 'O uživateli',
  'rovo-chat.view-agent.actions-label': 'Akce',
  'rovo-chat.view-agent.agent-instructions.copy-label': 'Kopírovat',
  'rovo-chat.view-agent.agent-instructions.copy-tooltip': 'Kopírovat pokyny',
  'rovo-chat.view-agent.agent-instructions.placeholder': 'Tento agent nemá žádné vlastní pokyny.',
  'rovo-chat.view-agent.all-knowledge-added': 'Všechny organizační znalosti',
  'rovo-chat.view-agent.behaviour-label': 'Chování',
  'rovo-chat.view-agent.beta-label': 'Beta',
  'rovo-chat.view-agent.beta-tag': 'Beta',
  'rovo-chat.view-agent.chat-to-agent-button': 'Chatovat s agentem',
  'rovo-chat.view-agent.close-button': 'Zavřít',
  'rovo-chat.view-agent.copied-instructions-tooltip-label': 'Zkopírováno',
  'rovo-chat.view-agent.copy-instructions-tooltip-label': 'Kopírovat',
  'rovo-chat.view-agent.created-by-label': '<text>od</text> {agentName}',
  'rovo-chat.view-agent.favourites-metadata-label': 'Počet oblíbených',
  'rovo-chat.view-agent.go-back-label': 'Zpět',
  'rovo-chat.view-agent.hidden-instructions-description':
    'Pokyny agentů Forge sestavených pomocí kódu jsou kvůli ochraně údajů skryty.',
  'rovo-chat.view-agent.hidden-instructions-title': 'Tyto pokyny jsou soukromé',
  'rovo-chat.view-agent.hidden-knowledge-description':
    'Agenti Forge sestavení pomocí kódu nepoužívají typické zdroje znalostí.',
  'rovo-chat.view-agent.inactive-action-tooltip': 'Neaktivní',
  'rovo-chat.view-agent.instructions-label': 'Pokyny',
  'rovo-chat.view-agent.knowledge-label': 'Znalosti',
  'rovo-chat.view-agent.member-count':
    '{count, plural, one {{count,number} člen} few {{count,number} členové} many {{count,number} člena} other {{count,number} členů}}',
  'rovo-chat.view-agent.modal-title': 'Procházet agenty',
  'rovo-chat.view-agent.no-actions': 'Žádné akce',
  'rovo-chat.view-agent.no-behaviour-placeholder': 'Tento agent nemá žádné vlastní chování.',
  'rovo-chat.view-agent.no-instruction-placeholder': 'Tento agent nemá žádné vlastní pokyny.',
  'rovo-chat.view-agent.no-knowledge-added': 'Žádné organizační znalosti',
  'rovo-chat.view-agent.no-scenarios': 'Žádné scénáře',
  'rovo-chat.view-agent.no-skills': 'Žádné dovednosti',
  'rovo-chat.view-agent.no-teams': 'Není součástí žádného týmu.',
  'rovo-chat.view-agent.open-chat-label': 'Otevřít chat',
  'rovo-chat.view-agent.reactions-metadata-label': 'Počet reakcí',
  'rovo-chat.view-agent.rovo-agent-label': 'Agent Rovo',
  'rovo-chat.view-agent.scenarios-label': 'Scénáře',
  'rovo-chat.view-agent.skills-label': 'Dovednosti',
  'rovo-chat.view-agent.teams-label': 'Týmy',
  'rovo-chat.view-agent.users-metadata-label': 'Počet uživatelů',
  'rovo.agent.scenarios.scenarioModal.actionsLabel': 'Akce',
  'rovo.agent.scenarios.scenarioModal.instructionsLabel': 'Pokyny',
  'rovo.agent.scenarios.scenarioModal.knowledgeSourcesLabel': 'Znalosti',
  'rovo.agent.scenarios.scenarioModal.mcpServersLabel': 'Servery MCP',
  'rovo.agent.scenarios.scenarioModal.noActions': 'Žádné akce',
  'rovo.agent.scenarios.scenarioModal.noInstructions': 'Žádné pokyny',
  'rovo.agent.scenarios.scenarioModal.noMcpServers': 'Žádné servery MCP',
  'rovo.agent.scenarios.scenarioModal.noSkills': 'Žádné dovednosti',
  'rovo.agent.scenarios.scenarioModal.skillsLabel': 'Dovednosti',
  'rovo.conversation.assistant.agent.deepResearchPill': 'Hluboký výzkum',
};
